<template>
  <form @submit.prevent="handleSubmit">
    <modal-card title="Add Manager" style="margin: 0 auto;" contains-dropdown>
      <b-field label="User">
        <user-select @change="user => (form.user_id = user.id)"></user-select>
      </b-field>

      <b-field label="Role">
        <b-select v-model="form.role">
          <option value="admin">Admin</option>
          <option value="moderator">Moderator</option>
          <option value="content">Content</option>
          <option value="marketer">Marketer</option>
          <option value="custom">Custom</option>
        </b-select>
      </b-field>
      <b-field label="Permissions">
        <div class="columns is-multiline mt-1">
          <div v-for="(permission, index) in groups" :key="index" class="column is-one-quarter">
            <div class="font-semibold">{{index}}</div>
            <div v-for="(anPermission) in permission" :key="anPermission.id" class="column is-one-quarter py-1">
              <b-checkbox v-model="form.permissions" :native-value="anPermission.id" class="mr-1 ">  {{ anPermission.action_name }} </b-checkbox>
            </div>
          </div>
        </div>
      </b-field>

      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">
          Close
        </button>

        <button
          class="button is-primary"
          :class="{ 'is-loading': form.processing }"
        >
          Add Manager
        </button>
      </div>
    </modal-card>
  </form>
</template>

<script>
import UserSelect from "@/modules/admin/components/selectors/UserSelect";

export default {
  components: {
    UserSelect
  },

  props: {
    added: {
      type: Function,
      required: true
    }
  },

  watch: {
    "form.role" : function (role){
      this.manager(role);
    },

    "form.permissions" : function (){
      if (this.form.permissions === []) {
        this.form.permissions = this.permissions.data.map(function (permission) {
          return permission.id;
        });
      }
    }
  },

  data() {
    return {
      permissions: new window.RemoteCollection(
        `/admin/api/manager/permissions`
      ).load(),
      form: new window.Form({
        user_id: null,
        role: "moderator",
        permissions: [2,5,7,8,11,12],
      })
    };
  },

  methods: {
    handleSubmit() {
      this.form.post("/admin/api/managers").then(this.whenAdded);
    },

    groupBy(array, key) {
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]){
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    },

    manager(role) {
      this.form.permissions = [];
      if (role === 'admin') {
        this.form.permissions = this.permissions.data.map(function (permission) {
          return permission.id;
        });
      }

      if (role === 'moderator') {
        let permissions = ['publishers', 'magazine',  'ads', 'wifi', 'banners', 'settings'];
        this.form.permissions = this.permissions.data.map(function (permission) {
            return permissions.includes(permission.title) ? permission.id : null;
        });
      }

      if (role === 'content') {
        let permissions = ['publishers', 'magazine',  'ads', 'review_accounts', 'banners', 'settings'];
        this.form.permissions = this.permissions.data.map(function (permission) {
          return permissions.includes(permission.title) ? permission.id : null;
        });
      }

      if (role === 'marketer') {
        let permissions = ['dashboard', 'subscription', 'wifi', 'analytics',  'publishers', 'magazine', 'settings'];
        this.form.permissions = this.permissions.data.map(function (permission) {
          return permissions.includes(permission.title) ? permission.id : null;
        });
      }
    },

    whenAdded(manager) {
      this.added(manager);

      this.$buefy.toast.open("New manager has been added.");

      this.$parent.close();
    }
  },
  computed:{
    groups(){
      return this.groupBy(this.permissions.data, 'title')
    },
  }
};
</script>
